import { Component, useState } from "react";
import { AlertTriangle, Send } from "lucide-react";
import { reportError } from "@/lib/errorReport";

function ReportBox({ error, info }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [state, setState] = useState("");
  const send = async () => {
    setState("sending");
    try { await reportError(error, { note: note || "Kullanıcı bildirdi", auto: false, componentStack: info }); setState("ok"); } catch { setState("fail"); }
  };
  if (state === "ok") return <p className="mt-3 text-[13px] text-emerald-700" data-testid="error-report-sent">Teşekkürler, hata yöneticiye bildirildi.</p>;
  if (!open) return <button className="mt-3 ml-4 text-[13px] underline text-rose-800 inline-flex items-center gap-1" onClick={() => setOpen(true)} data-testid="error-report-open"><Send className="h-3.5 w-3.5" />Hatayı bildir</button>;
  return (
    <div className="mt-3 space-y-2">
      <textarea className="w-full border rounded p-2 text-[13px]" rows={3} maxLength={1000} placeholder="Hata oluştuğunda ne yapıyordunuz? (isteğe bağlı)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="error-report-note" />
      <button className="h-8 px-3 rounded bg-rose-700 text-white text-[13px] disabled:opacity-60" disabled={state === "sending"} onClick={send} data-testid="error-report-send">{state === "sending" ? "Gönderiliyor…" : "Bildir"}</button>
      {state === "fail" && <span className="ml-2 text-[12px] text-rose-700" data-testid="error-report-fail">Gönderilemedi – bağlantınızı kontrol edip tekrar deneyin.</span>}
    </div>
  );
}

// Tek bir sayfa/bileşen hatası tüm uygulamayı çökertmesin
export class ErrorBoundary extends Component {
  state = { error: null, info: "" };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Arayüz hatası:", error, info?.componentStack);
    this.setState({ info: info?.componentStack || "" });
    reportError(error, { componentStack: info?.componentStack || "" }).catch(() => {});
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="panel p-5 border-rose-200 bg-rose-50 max-w-xl" role="alert" data-testid="error-boundary">
        <div className="flex items-center gap-2 font-semibold text-rose-800"><AlertTriangle className="h-4 w-4" />Bu bölüm yüklenirken bir hata oluştu</div>
        <p className="text-[13px] text-rose-700 mt-1">Diğer sayfalar çalışmaya devam ediyor. Hata otomatik olarak yöneticiye iletildi; ayrıntı eklemek isterseniz “Hatayı bildir”e tıklayın.</p>
        <pre className="text-[11px] text-rose-600 mt-2 whitespace-pre-wrap">{String(this.state.error?.message || this.state.error)}</pre>
        <button className="mt-3 text-[13px] underline text-rose-800" onClick={() => this.setState({ error: null })} data-testid="error-boundary-retry">Tekrar dene</button>
        <ReportBox error={this.state.error} info={this.state.info} />
      </div>
    );
  }
}
